import Page from "../../Components/Page";


export default function Analytics() {
    return (
        <Page title="Analytics" grid fullHeight>
        </Page>
    );
}
